export const configs = {
  API_URL: process.env.REACT_APP_API_URL,
  APP_URL: process.env.REACT_APP_FRONTEND_URL,
  NAMESPACE: process.env.REACT_APP_CUSTOMER,
  OPERATOR_KEY: 'operator',
  TOKEN_KEY: 'tk',
  SA_TOKEN_KEY: 'satk',
  CDN_URL: process.env.REACT_APP_CDN_URL,
  IMAGE_SERVICE_URL: process.env.REACT_APP_IMAGE_SERVICE_URL,
  UHUB_URL: process.env.REACT_APP_UHUB_API,
}

export default configs
